import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { Card } from 'core/components/card';
import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';
import Section from 'core/components/section';
import useStyles from './settings.styles';

const LeadSourceSettings = ({ leadSourceOptions }) => {
  const classes = useStyles();
  const { canModifyAffinityAndLeadSource, canToggleEmployeeDiscount } = useSession();

  return (
    <Section title="Offer Source" type="SubSection">
      <Card className={classes.overflowContainer} type="secondary">
        <Grid container item xs={12}>
          <Grid container item xs={12}>
            {canToggleEmployeeDiscount && (
              <Grid container className={canModifyAffinityAndLeadSource ? classes.withBottomLine : null}>
                <FormField label="Employee Discount" xs={8} type="switch" name="global.employeeDiscount" mode="dark" />
              </Grid>
            )}
            <Grid container spacing={2}>
              {canModifyAffinityAndLeadSource && (
                <FormField
                  label="Lead Source"
                  xs={8}
                  type="select"
                  name="leadSource"
                  options={leadSourceOptions}
                  mode="dark"
                />
              )}
              <FormField
                label="Affinity Code"
                xs={!canModifyAffinityAndLeadSource ? 8 : 4}
                type="affinity"
                name="global.affinity"
                mode="dark"
                fast={false}
                disabled={!canModifyAffinityAndLeadSource}
              />
              <FormField label="Rep" xs={8} type="value" name="rep" mode="dark" />
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Section>
  );
};

LeadSourceSettings.propTypes = {
  leadSourceOptions: PropTypes.array.isRequired
};

export default LeadSourceSettings;
